import { isEmpty } from 'lodash-es';
import { useGetIsLiveRtpGamesLoaded } from '../useGetIsLiveRtpGamesLoaded';
import { useGetLiveRtpGamesSectionsIds } from '../useGetLiveRtpGamesSectionsIds';
import { useGetLiveRtpMixedGamesIds } from '../useGetLiveRtpMixedGamesIds';

export const useGetIsEmptyLiveRtpCategory = (feedName: string) => {
  const mixedLiveRtpGamesIds = useGetLiveRtpMixedGamesIds({ feedName });
  const liveRtpGamesSectionsIds = useGetLiveRtpGamesSectionsIds({ feedName });
  const isLiveRtpGamesLoaded = useGetIsLiveRtpGamesLoaded();

  if (!isLiveRtpGamesLoaded) {
    return false;
  }

  // the whole category considered empty if any section is empty
  return [{ gamesIds: mixedLiveRtpGamesIds }, ...liveRtpGamesSectionsIds].some(
    (section) => isEmpty(section.gamesIds)
  );
};
